import { useEffect } from "react";
import Card from "./card";
import { Box, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../context/themeContext";
import { useSelector } from "react-redux";
import useManageProjects from "../../../../../hooks/useManageProjects";

const Liked = () => {
  const { likedProjects } = useSelector((state) => state.manageProjects);
  const { fetchLikedProjects } = useManageProjects();
  const { theme } = useTheme();
  const user = useSelector((state) => state.user.value);

  useEffect(() => {
    fetchLikedProjects(user);
  }, []);

  const renderProjects = likedProjects?.map((project, index) => {
    return <Card project={project} key={index} />;
  });

  return (
    <Box className={styles.hosted}>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.darkgrey.darkgrey600,
          fontSize: "24px",
          fontWeight: "500",
        }}
      >
        {likedProjects.length} Liked Projects
      </Typography>
      <Box className={styles.liked}>{renderProjects}</Box>
    </Box>
  );
};

export default Liked;
